export default "__VITE_PUBLIC_ASSET__2b37b66f__"